import { useMemo } from 'react';

export default function useGroupStudents({ students, groupId }) {
  const groupStudents = useMemo(() => {
    return students.filter((s) => s.group?._id === groupId);
  }, [students, groupId]);

  const studentsNotInGroup = useMemo(() => {
    return students.filter((s) => !s.group || s.group._id !== groupId);
  }, [students, groupId]);

  return {
    groupStudents,
    studentsNotInGroup,
  };
}
